"use client";
import { useState, useEffect } from 'react';
import { Markdown } from '../../components/Markdown';
import { Button } from '../../components/ui/button';
import { Card } from '../../components/ui/card';
import { EmptyState } from '../../components/EmptyState';

export default function ScenarioRunnerPage() {
    const [scenarios, setScenarios] = useState<string[]>([]);
    const [selectedScenario, setSelectedScenario] = useState<string | null>(null);
    const [scenarioContent, setScenarioContent] = useState<string>('');

    useEffect(() => {
        // In a real implementation, this would fetch from an API or static files
        // For now, using placeholder data
        setScenarios(['crisis_negotiation_01', 'empathy_round_01', 'moral_dilemma_01']);
    }, []);

    useEffect(() => {
        if (selectedScenario) {
            fetch(`/scenarios/${selectedScenario}.md`)
                .then(r => (r.ok ? r.text() : ''))
                .then(setScenarioContent)
                .catch(() => setScenarioContent(''));
        }
    }, [selectedScenario]);

    return (
        <div className="space-y-6 max-w-4xl">
            <div className="flex items-center justify-between">
                <h1 className="text-2xl md:text-3xl font-semibold">Scenario Runner</h1>
                <Button onClick={() => setSelectedScenario(null)} variant="outline">
                    Back to List
                </Button>
            </div>

            {!selectedScenario ? (
                <div>
                    <p className="text-muted-foreground mb-4">
                        Select a scenario to practice your judgment and response skills.
                    </p>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        {scenarios.length > 0 ? (
                            scenarios.map(slug => (
                                <Card
                                    key={slug}
                                    className="p-6 cursor-pointer hover:ring-1 ring-border transition-all"
                                    onClick={() => setSelectedScenario(slug)}
                                >
                                    <div className="text-lg font-semibold">
                                        {slug.replace(/_/g, ' ').replace(/\b\w cas/g, c => c.toUpperCase())}
                                    </div>
                                    <div className="text-sm text-muted-foreground mt-1">Click to start</div>
                                </Card>
                            ))
                        ) : (
                            <EmptyState title="No scenarios" message="No scenarios available" />
                        )}
                    </div>
                </div>
            ) : (
                <div className="space-y-4">
                    {scenarioContent ? (
                        <Markdown content={scenarioContent} />
                    ) : (
                        <EmptyState title="Loading" message="Loading scenario..." />
                    )}
                </div>
            )}
        </div>
    );
}

